import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class BcProductDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BRANDCENTRAL, apiHelper);
  }

  public searchAdvertisers(q: string): Observable<any> {
    let url: string = this.apiHelper.getServiceName('data') + this.getResource() + '/search/advertisers?q=' + encodeURIComponent(q);
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public searchBrands(q: string): Observable<any> {
    let url: string = this.apiHelper.getServiceName('data') + this.getResource() + '/search/brands?q=' + encodeURIComponent(q);
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public searchProducts(params: any): Observable<any> {
    let query = '';
    const tmp = Object.keys(params);
    tmp.forEach((key, i) => {
      if (params[key]) {
        query += key + '=' + encodeURIComponent(params[key]) + '&';
      }
    });
    let url: string = this.apiHelper.getServiceName('data') + this.getResource() + '/search/products?' + query;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public searchProductsDetailed(productName: string, days: number, markets: string[], startDate: any, endDate: any): Observable<any> {
    //this is just to handle cases where the user only inputs &
    const encodedProductName = encodeURIComponent(productName);
    let url: string = this.apiHelper.getServiceName('data') + this.getResource() + '/search/products?product_name=' + encodedProductName + '&days=' + days + '&markets=' + encodeURIComponent(JSON.stringify(markets)) + '&startDate=' + startDate + '&endDate=' + endDate;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }
}
